import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

export const validateParty = yup.object({
  full_name: yup
    .string()
    .required("Supplier Name is required")
    .nonNullable("Supplier Name is required"),
  account: yup
    .string()
    .required("Account Type is required")
    .nonNullable("Account Type is required"),
  vat_pan: yup
    .string()
    // .required("Comapany (PAN/VAT) is required")
    // .nonNullable("Comapany (PAN/VAT) is required"),
    .optional()
    .nullable(),
  email: yup.string().email("Email is not valid").optional().nullable(),
  mobile_number: yup
    .string()
    .optional()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      if (/^\+\d{1,4}$/.test(value.trim())) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
});

export const validateCustomer = yup.object({
  full_name: yup
    .string()
    .required("Supplier Name is required")
    .nonNullable("Supplier Name is required"),
  account: yup
    .string()
    .required("Account Type is required")
    .nonNullable("Account Type is required"),
  vat_pan: yup.string().optional().nullable(),
  email: yup.string().email("Email is not valid").optional().nullable(),
  mobile_number: yup
    .string()
    .optional()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value || value.trim() === "") return true;
      if (/^\+\d{1,4}$/.test(value.trim())) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
});

